import { env } from '@monorepo/env'
import { Platform } from 'react-native'
import DeviceInfo from 'react-native-device-info'

export const getApplicationName = Platform.OS !== 'web' ? DeviceInfo.getApplicationName : () => env.EXPO_PUBLIC_APP_NAME as string
export const getBundleId = Platform.OS !== 'web' ? DeviceInfo.getBundleId : () => env.EXPO_PUBLIC_BUNDLE_ID as string
